/*
 * $Id:: globalsSlice.js 2021/01/11 10:04 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { createSlice } from '@reduxjs/toolkit';

import { getLocale, setLocale } from '../providers';
import { GLOBALS_SLICE_NAME as SLICE_NAME } from './constants';

export const slice = createSlice({
    name: SLICE_NAME,
    initialState: {
        globals: false,
        filtersOptions: {
            trademarks: [],
            designs: [],
            eServices: [],
        },
        countries: null,
        states: null,
        language: getLocale(),
        loading: false,
        globalLoading: false,
        error: false,
    },
    reducers: {
        globals: (state, action) => {
            const { design, eservice, trademark, locarno, correspondence, ...rest } = action.payload;
            const updatedCorrespondence = Object.keys(correspondence).reduce((acc, cur) => ({ ...acc, [`${cur}Corr`]: correspondence[cur] }), {});
            const { dsFilteringTypes, tmFilteringTypes } = eservice;
            const dsEserviceTypes = dsFilteringTypes.map(({ label, key }) => ({ label, key }));
            const tmEserviceTypes = tmFilteringTypes.map(({ label, key }) => ({ label, key }));
            const eservicesTypes = {
                design: [{ label: 'ds.efiling', key: 'DS' }].concat(dsEserviceTypes),
                trademark: [{ label: 'tm.efiling', key: 'TM' }].concat(tmEserviceTypes),
            };

            state.globals = rest;
            state.filtersOptions = {
                design: { ...design, locarno, ...updatedCorrespondence },
                eservice: eservice,
                trademark: { ...trademark, ...updatedCorrespondence },
                //added for the case of common (TM and DS), so called 'all' tab
                all : { ...updatedCorrespondence },
                eservicesTypes,
            };
        },
        setCountries: (state, action) => {
            state.countries = action.payload;
        },
        setStates: (state, action) => {
            state.states = action.payload;
        },
        setLanguage: (state, action) => {
            state.language = action.payload;
            setLocale(action.payload);
        },
        loading: (state, action) => {
            state.loading = action.payload;
        },
        globalLoading: (state, action) => {
            state.globalLoading = action.payload;
        },
        error: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const globals = (state) => state[SLICE_NAME];
export const countries = (state) => state[SLICE_NAME].countries;
export const states = (state) => state[SLICE_NAME].states;
export const loading = (state) => state[SLICE_NAME].loading;
export const globalLoading = (state) => state[SLICE_NAME].globalLoading;
export const error = (state) => state[SLICE_NAME].error;
export default slice.reducer;
